import React from "react";

import {
  Baby,
  Bath,
  Briefcase,
  Coffee,
  Droplet,
  EyeClosed,
  Footprints,
  Glasses,
  HeartPulse,
  Lamp,
  Laptop,
  PawPrint,
  Pill,
  Scissors,
  Shirt,
  Sofa,
  TentTree,
  UtensilsCrossed,
} from "lucide-react";

export const INDUSTRIES = [
  "Accessories",
  "Activities & Outdoor",
  "Baby & Kids",
  "Bags & Luggage",
  "Beauty",
  "Clothing",
  "Drinks & Beverages",
  "Food",
  "Hair Care",
  "Health & Wellness",
  "Home Goods",
  "Home Decor",
  "Personal Care",
  "Pets",
  "Shoes",
  "Skincare",
  "Supplements",
  "Tech",
] as const;

export type Industry = (typeof INDUSTRIES)[number];

export const INDUSTRY_ICONS: Record<Industry, React.JSX.Element> = {
  Accessories: <Glasses />,
  "Activities & Outdoor": <TentTree />,
  "Baby & Kids": <Baby />,
  "Bags & Luggage": <Briefcase />,
  Beauty: <EyeClosed />,
  Clothing: <Shirt />,
  "Drinks & Beverages": <Coffee />,
  Food: <UtensilsCrossed />,
  "Hair Care": <Scissors />,
  "Health & Wellness": <HeartPulse />,
  "Home Goods": <Sofa />,
  "Home Decor": <Lamp />,
  "Personal Care": <Bath />,
  Pets: <PawPrint />,
  Shoes: <Footprints />,
  Skincare: <Droplet />,
  Supplements: <Pill />,
  Tech: <Laptop />,
};
